import { CtStockLedger } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      contentType: 'stock',
      type: 'link',
      required: true
    },
    count: {
      field: 'count',
      label: 'Stock Count',
      validator: () => true,
      type: 'number',
      default: 0,
      required: true
    },
    catalogue: {
      field: 'catalogue',
      label: 'Catalogue',
      validator: () => true,
      contentType: 'catalogue',
      type: 'link',
      required: false
    },
    tags: {
      field: 'tags',
      label: 'Tags',
      validator: () => true,
      type: 'array',
      required: false
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtStockLedger>(
  ContentType.StockLedger, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
